export const DEFAULT_MAX_NO_SUBMIT_TIME = 60000;
export const DEFAULT_MINIMUM_SUBMIT_WAIT_TIME = 1000;
export const SUBMIT_TIMER_TICK_MS = 250;
export const MAX_VIDEO_REPLAYS = 5;

export const RECORDING_ACTIVITY_TYPE = 'freeAnswer';

export function getMinimumSubmitWaitTime() {
  return DEFAULT_MINIMUM_SUBMIT_WAIT_TIME;
}

export function getMaxNoSubmitTime(shouldExtendTimeout, timeoutExtensionMultiplier) {
  const base = DEFAULT_MAX_NO_SUBMIT_TIME;
  const multiplier = Number(timeoutExtensionMultiplier);
  if (!shouldExtendTimeout || !Number.isFinite(multiplier) || multiplier <= 1) {
    return base;
  }
  return Math.round(base * multiplier);
}

export const LOG =
  process.env.NODE_ENV !== 'production'
    ? (...args) => console.log('[FREE-ANSWER]', ...args)
    : () => {};
